angular.module('lead')
    .service('LeadStatusService', function (){
        this.statuses = [ 'ERROR', 'WAIT', 'START', 'PROSPECT', 'IN', 'NOD', 'OUT' ]
    })
    .component('leadStatusLabel', {
        bindings: {
            status: '<'
        },
        template: '<span class="label label-default lead-status {{$ctrl.status}}">{{ \'lead.status.\'.concat($ctrl.status) | translate }}</span>'
    })
